import React from 'react';

export const pageMeta = {
  "name": "JS Google Chart",
  "link": "/javascript/graphics/google-chart"
};

export default function JavascriptGraphicsGoogleChart() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS Google Chart</h2>
      <p>Route: /javascript/graphics/google-chart</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
